export { default as getTarget } from './getTarget';
export { default as isDomElement } from './isDomElement';
